import { config } from 'src/core/config';

function pathBase(partnerId?: number, addressId?: string): string | undefined {
  if (!partnerId || !addressId) return;
  return `${partnerId}/address/${addressId}`;
}

export function filePath(
  partnerId?: number,
  addressId?: string,
  fileKey?: string,
): string | undefined {
  const base = pathBase(partnerId, addressId);
  if (!base || !fileKey) return;
  return `attachments/${base}/${fileKey}`;
}

export function fileUrl(
  partnerId?: number,
  addressId?: string,
  fileKey?: string,
): string | undefined {
  const path = pathBase(partnerId, addressId);
  if (!path || !fileKey) return;
  return `${config.s3AttachmentsUrl}${path}/${fileKey}`;
}

export function storagePath(partnerId?: number, addressId?: string): string | undefined {
  return pathBase(partnerId, addressId);
}
